// extracted by mini-css-extract-plugin
module.exports = {"selectedElement":"styles_selectedElement__19tjS","title":"styles_title__2oe5I","removeBtn":"styles_removeBtn__1AMm9","removeIcon":"styles_removeIcon__nrIBY"};